module.exports = __webpack_public_path__ + "img/renew.5bcf6a23.svg";